module.exports = __webpack_public_path__ + "img/heart_5_bj.21d62b96.png";